// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { promiseMiddleware } from '@adobe/redux-saga-promise';
import { Action, applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';

import { withSentryReduxEnhancer } from '@/infrastructure/sentry';
import { rootReducer, rootSaga } from '@/model';
import { saveStore } from '@/model/store.holder';
import { RootState } from '@/model/types';

const isDev = process.env.NODE_ENV === 'development';
const sagaMiddleware = createSagaMiddleware<RootState>();

const middlewares = [promiseMiddleware, sagaMiddleware];
const middleware = withSentryReduxEnhancer(
  isDev ? composeWithDevTools(applyMiddleware(...middlewares)) : applyMiddleware(...middlewares),
);

export default (): { store: Store<RootState, Action> } => {
  const store: Store<RootState, Action> = createStore(rootReducer(), middleware);
  sagaMiddleware.run(rootSaga);
  saveStore(store);
  return { store };
};
